<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th class="border-0">#</th>
        <th class="border-0">Nome</th>
        <th class="border-0 text-center">Preço</th>
        <th class="border-0 text-center">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in items" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: editRouteName, params: { [editParamKey]: row.id } }">{{ row.name }}</d-link>
        </td>
        <td class="td-2 text-right">{{ addCurrencyMask(row.price) }}</td>
        <td class="td-2 text-center">
          <delete-button :item-id="row.id" :delete-event="deleteEvent" />
        </td>
      </tr>
      <tr v-if="items.length === 0">
        <td colspan="4" class="no-content">Ainda não tem nenhum item cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="cancelDelete"
      :confirm="confirmDelete"
      :title="modalTitle"
      :message="modalMessage"
    />
  </table>
</template>

<script>
import Events from '_utils/events';
import CurrencyMask from '_common/mixins/CurrencyMask';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import DeleteButton from '_common/ui/DeleteButton.vue';

export default {
  name: 'EntityTable',
  mixins: [CurrencyMask],
  components: {
    DeleteButton,
    ConfirmationModal,
  },
  props: {
    items: Array,
    editRouteName: String,
    editParamKey: String,
    deleteEvent: String,
    modalTitle: String,
    modalMessage: String,
    cancelDelete: Function,
    confirmDelete: Function,
  },
  mounted() {
    Events.$on(this.deleteEvent, itemId => {
      this.$emit('select-item-to-delete', itemId);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}
</style>
